import { useMutation } from "react-query";
import { createRevisionLogs, submitRevision, importFiles } from "../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom/dist";
import useSnackMessage from "../../../hooks/useSnackMessage";
import { useEffect, useState } from "react";
import { updateState } from "../../../redux/commonSlice";
import { updateReviewState } from "../../../redux/reviewSlice";

export default (requestType, afterSuccessCallback)=> {
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
  const [importFilesStatus, setImportFilesStatus] = useState("");
  const [submitRevisionStatus, setSubmitRevisionStatus] = useState("");
  const [createLogStatus, setCreateLogStatus] = useState("");
  const [checkNewVideoStatus, setCheckNewVideoStatus] = useState("");
  const [revisionLogsStatus, setRevisionLogsStatus] = useState("");
  const [enableRevisionLogs, setEnableRevisionLogs] = useState(false);
  // const [uploadedVideos, refetchList] = useUploadedList(true);
 // const [eventId, setEventId] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showSnackbar] = useSnackMessage();

 

  //POST API Request to  to send seleceted media files
  const { mutate: importFilesMutate, isLoading: importFilesLoading } =
    useMutation(importFiles, {
      onSuccess: (response, variables, context) =>
        importFilesSuccessHandler(response, variables, context),
      onError: (error, variables, context) =>
        importFilesErrorHandler(error, variables, context),
    });

  const importFilesSuccessHandler =  (response, variables, context) => {
    const responseObject = response?.data;
    const responseData = responseObject?.data
    if (responseObject?.http_code == 200) {
 
     // showSnackbar(responseObject);
    //  console.log(responseData)
   // refetchList()
      setImportFilesStatus("success");
    }
  };

  const importFilesErrorHandler = (error, variables, context) => {
    // setSubmitFlag(false);
    setImportFilesStatus("error");
    const errorObject = error?.response?.data;
    console.log(errorObject)

  };

   //////////////////////POST API Request to create revision logs/////////////////////////////////////////////////////////////

   const { mutate: createLogMutate, isLoading: createLogLoading } = useMutation(
    createRevisionLogs,
    {
      onSuccess: (response, variables, context) =>
        createLogSuccessHandler(response, variables, context),
      onError: (error, variables, context) =>
        createLogErrorHandler(error, variables, context),
    }
  );

  const createLogSuccessHandler = (response, variables, context) => {
    const responseObject = response?.data;
    const responseData = responseObject?.data
    if (responseObject?.http_code == 200) {
     // refetchRevisionLogs()
      setCreateLogStatus("success");
    //  showSnackbar(responseObject);
    }
   
  };

  const createLogErrorHandler = (error, variables, context) => {
    const errorObject = error?.response?.data;
   // showSnackbar(errorObject)
      setCreateLogStatus("error");
  };


  //PUT API Request to submit a revision
  const { mutate: submitRevisionMutate, isLoading: submitRevisionLoading } =
    useMutation(submitRevision, {
      onSuccess: (response, variables, context) =>
        submitRevisionSuccessHandler(response, variables, context),
      onError: (error, variables, context) =>
        submitRevisionErrorHandler(error, variables, context),
    });

  const submitRevisionSuccessHandler = (response, variables, context) => {
    // console.log("event id", data?.data)
    // if (data?.data?.data) {
      // dispatch(updateState({ event_details: {...commonReducer.event_details, revision: {...commonReducer.event_details.revision, submitted: true}, revision_left: commonReducer.event_details.revision_left - 1}, under_revision: true }));
       dispatch(updateReviewState({revision_logs: []})) 
       dispatch(updateState({new_video: false}))
       //   // setEventId(data?.data?.data?.id)
    //   setSnackbarProps({
    //     type: "success",
    //     flag: true,
    //     message: "Congratulations! Event edited successfully",
    //   });
       setSubmitRevisionStatus("success");
    // }
  };

  const submitRevisionErrorHandler = (error, variables, context) => {
    // setSubmitFlag(false);
    // if (data) {
    //   if (data?.response?.status == 401) {
    //     window.localStorage.removeItem("token");
    //     dispatch(resetState());
    //   }
    //   setSnackbarProps({
    //     type: "error",
    //     flag: true,
    //     message: data?.response?.data?.error,
    //   });
    //   setsubmitRevisionStatus("error");
    //   //  console.log("error", data)
    // }
  };

   //GET API for Revision Logs ***********************************************************

  //  const {
  //   data: revisionLogsData,
  //   isLoading: revisionLogsLoading,
  //   error: revisionLogsError,
  //   refetch: refetchRevisionLogs,
  // } = useQuery(
  //   [
  //     `revisionLog${commonReducer.event_details.revision?.id}`,
  //     commonReducer.event_details.revision?.id,
  //   ],
  //   () => getRevisionLogs({revision_id: commonReducer.event_details.revision?.id }),
  //   { enabled: enableRevisionLogs, retry: false }
  // );

  // useEffect(()=> {
  //   if(revisionLogsData) {
  //       setEnableRevisionLogs(false)
  //       setRevisionLogsStatus("success");
  //      // console.log(revisionLogsData?.data?.data?.revision_logs)
  //       dispatch(updateReviewState({revision_logs: revisionLogsData?.data?.data?.revision_logs }))
  //   }
  // }, [revisionLogsData])

  const revisionLogs = ()=> {
    if(commonReducer.event_details.revision.id) {
        
    }
  }

  

  useEffect(() => {
    if (importFilesLoading) {
      setImportFilesStatus("loading");
    }
    if (submitRevisionLoading) {
      setSubmitRevisionStatus("loading");
    }
    if (createLogLoading) {
      setCreateLogStatus("loading");
    }
    // if(revisionLogsLoading) {
    //     setRevisionLogsStatus("loading");
    // }
   

    // return ()=>{ setStatus("")}
  }, [importFilesLoading, submitRevisionLoading, createLogLoading]);

  //Functions to request API as per incoming mutation type
  const revisionRequest = (data) => {
    switch (requestType) {
      case "import-files":
        return importFilesMutate(data);
    //   case "submit-revision" :   return submitRevisionMutate(data);
    //   case "create-log": return createLogMutate(data);
    //   case "logs": return (commonReducer.event_details.revision.id != null && setEnableRevisionLogs(true))
      // case "verify-token": return checkVerifyToken(data) ;
      // case "reset-password" : return resetPasswordMutate(data) ;
      default:
        return () =>
          console.log(
            "requested operation is not available. Available options: signin | signup | forgot-password | reset-password"
          );
    }
  };

  return [
    revisionRequest,
    requestType == "import-files" ? importFilesStatus : ""
    //   requestType == 'submit-revision' ? submitRevisionStatus : 
        // requestType == 'create-log' ? createLogStatus : 
           // requestType == 'logs' ? revisionLogsStatus : ""
    
  ];
}